/* eslint-disable no-undef */
// import '../../styles/theme.scss'

import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

// from slate; necessary?
import "element-matches";
import { focusHash, bindInPageLinks } from "@shopify/theme-a11y";

import "../ui/core-flyd";
import "../ui/components/panelswapper";
import "../ui/components/popup";
import "../ui/components/toggle";
import "../ui/components/slideshow_2";
import "../ui/components/carousel_2";
import "../ui/components/shutter";
import "./sliding_menu";
import "./related_products";
// import './featured_items'
import "./zoom";

import "../shopify/product";
import "../shopify/addresses";
import "../shopify/login";
import "../shopify/cart";

// workaround: sections.load doesn't work under parcel
import * as sections from "@shopify/theme-sections";

// import * as images from '@shopify/theme-images'
// import {
//   first
// } from '../ui/core/functions'

// Common a11y fixes
focusHash();
bindInPageLinks();

// from slate; necessary?
// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className =
    document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
} else {
  [...document.getElementsByClassName("cookie-message")].forEach((n) => {
    n.className = n.className.replace("cookie-message", "");
  });
}

document.findByRole("province-selector").forEach((m) => {
  [...m.getElementsByTagName("option")]
    .filter((c) => c.value === m.dataset.default)
    .forEach((c) => {
      c.selected = "selected";
    });
});

import Dispatcher from "../ui/core/dispatcher-flyd";

Dispatcher.register((payload) => {
  if (payload.type === "products-loaded") {
    const select = document.querySelector("[data-product-form] select");
    if (select != null) {
      select.dispatchEvent(new Event("change"));
    }
  }
});

window.addEventListener("load", () => {
  sections.load("product");
});

window.addEventListener("scroll", () => {
  const body = document.querySelectorAll("body")[0];
  // const amount = 129;
  const amount = 90;
  if (document.scrollingElement.scrollTop > amount) {
    body.addClass("pinned");
  } else {
    body.removeClass("pinned");
  }
});


